import { useState } from "react";

import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Tab4Table1 from "./Tab4Table1";
import {
	useCustomerDetailsMutation,
	useCustomerGroupDetailsMutation,
} from "../../../../store/api/itemapi";
const Tab4 = ({
	Default_Sales_Unit_of_Measure,
	Max_Discount,
	Allow_Sales,
	Grant_Commission,
	Reading_required,
	setselected_customer_details_data,
	setRows5,
	rows5,
}) => {
	const [CustomerDetailsApi] = useCustomerDetailsMutation();
	const [CustomerGroupDetailsApi] = useCustomerGroupDetailsMutation();
	return (
		<>
			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Sales Details</p>
				</div>
				<div className="col-6 ">
					<div className="mb-3">
						<SelectSearch
							list={
								Default_Sales_Unit_of_Measure.Default_Sales_Unit_of_Measure_list
							}
							style={{
								height: "30px",
								border: Default_Sales_Unit_of_Measure.Error
									? "1px solid red"
									: "",
							}}
							label="Default Unit Of Measure"
							getOptionLabel={(item) =>
								item.isNew ? "+ Create New Default UOM" : item.name
							}
							getOptionValue={(item) => item.name}
							createNewUrl="/master/uom/create-uom"
							createNewLabel="Create New Default UOM"
							value={
								Default_Sales_Unit_of_Measure.select_Default_Sales_Unit_of_Measure
							}
							onChange={(val) =>
								Default_Sales_Unit_of_Measure.setselect_Default_Sales_Unit_of_Measure(
									val
								)
							}
						/>
					</div>
				</div>

				<div className="col-6 ">
					<div className="mb-1">
						<Input
							id="Max_Discount"
							label="Max Discount (%)"
							style={{ height: "30px" }}
							value={Max_Discount.Max_Discount}
							onChange={(e) => Max_Discount.setMax_Discount(e.target.value)}
						/>
					</div>
				</div>

				<div className="col-2 ">
					<div className="mb-3">
						<Checkbox
							id="Allow_Sales"
							label="Allow Sales"
							value={Allow_Sales?.Allow_Sales}
							onChange={(val) => Allow_Sales?.setAllow_Sales?.(val)}
						/>
					</div>
				</div>

				<div className="col-2 ">
					<div className="mb-3">
						<Checkbox
							id="Grant_Commission"
							label="Grant Commission"
							value={Grant_Commission?.Grant_Commission || false}
							onChange={(val) => Grant_Commission?.setGrant_Commission?.(val)}
						/>
					</div>
				</div>

				<div className="col-4">
					<div className="mb-3">
						<Checkbox
							id="Reading_required"
							label="Reading required"
							value={Reading_required?.Reading_required || false}
							onChange={(val) => Reading_required?.setReading_required?.(val)}
						/>
						<p
							style={{
								paddingLeft: "25px",
								paddingRight: "14px",
								fontWeight: 400,
								fontSize: "9px",
								lineHeight: "16px",
								letterSpacing: "0",
								color: "#00000099",
								fontFamily: "Roboto, sans-serif",
							}}
						>
							If the item requires Gas or Electricity or similar meter reading
							to charge the customer.
						</p>
					</div>
				</div>
			</div>

			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Customer Details </p>
				</div>

				<Tab4Table1
					setselected_customer_details_data={setselected_customer_details_data}
					list_customer_data={CustomerDetailsApi}
					list_customer_group={CustomerGroupDetailsApi}
					rows5={rows5}
					setRows5={setRows5}
				/>
			</div>
		</>
	);
};

export default Tab4;
